import React from 'react';
import { IOldIconProps } from './type';

const SocialTikTok: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 19}
      height={height || 20}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.5 8.20169C16.7306 8.2058 15.0046 7.66934 13.5658 6.6681V13.6511C13.5654 14.9444 13.1587 16.2068 12.4004 17.2694C11.642 18.332 10.568 19.1442 9.32199 19.5974C8.076 20.0505 6.71739 20.1231 5.42784 19.8053C4.13828 19.4876 2.97925 18.7946 2.10571 17.8192C1.23218 16.8437 0.685777 15.6323 0.539576 14.3468C0.393376 13.0613 0.654342 11.763 1.28758 10.6256C1.92082 9.48819 2.89615 8.56583 4.08315 7.98185C5.27015 7.39788 6.61224 7.18013 7.92997 7.35772V10.8699C7.32698 10.6855 6.67947 10.6911 6.07991 10.8858C5.48036 11.0805 4.95942 11.4544 4.59148 11.9541C4.22355 12.4539 4.02745 13.0538 4.03117 13.6684C4.03489 14.2829 4.23826 14.8806 4.61222 15.376C4.98618 15.8715 5.51161 16.2394 6.11348 16.4272C6.71536 16.6151 7.36289 16.6132 7.96361 16.4219C8.56433 16.2306 9.08752 15.8597 9.45846 15.3621C9.8294 14.8645 10.0291 14.2657 10.0291 13.6511V0H13.5658C13.5634 0.290363 13.5884 0.580329 13.6406 0.866235C13.7635 1.50447 14.019 2.11163 14.3916 2.65057C14.7641 3.1895 15.2458 3.64889 15.8073 4.00062C16.606 4.51407 17.5424 4.78774 18.5 4.78754V8.20169Z"
        fill={color}
      />
    </svg>
  );
};

export default SocialTikTok;
